import React from "react";
import cx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { AVATAR_SIZE } from "./constants";
import { getUserAccountData } from "./getData";
export var UserAccountButton = function (_a) {
    var businessUnit = _a.businessUnit, country = _a.country, avatar = _a.avatar, isOpen = _a.isOpen, onClick = _a.onClick;
    var _b = getUserAccountData(businessUnit, country), _c = _b[1], avatarAlt = _c.avatarAlt, buttonLabel = _c.buttonLabel;
    var baseClass = "group bg-transparent cat-button text-gray-200 block focus:outline-none";
    var layoutClass = "px-0 mx-auto";
    var transitionClass = "hover:text-primary-200 transition-text duration-200";
    var imageClass = "border-solid border-2 border-primary-300 rounded-full h-8 w-8 mr-3";
    var chevronClass = cx({ "rotate-180": isOpen }, "w-1.5 md:group-hover:rotate-180 transition-transform duration-200");
    return (React.createElement("button", { className: cx(baseClass, layoutClass, transitionClass), type: "button", onClick: onClick, "aria-label": buttonLabel },
        React.createElement("div", { className: "flex items-center h-16 w-full md:w-16" },
            React.createElement("span", { className: "pr-3" },
                React.createElement("img", { className: imageClass, src: avatar, alt: avatarAlt, width: AVATAR_SIZE, height: AVATAR_SIZE, loading: "lazy", decoding: "async" })),
            React.createElement(FontAwesomeIcon, { icon: faCaretDown, className: chevronClass }))));
};
//# sourceMappingURL=UserAccountButton.js.map